import { FormattedMessage } from "react-intl";

import { TwcOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";
import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils/logos/teamwork-collection-logo";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { Headings } from "../../components/headings";
import { SwitchYourSiteMessage } from "../components/switch-your-site-message";

export const CrossflowEligibleUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    const headingText = (
        <FormattedMessage
            id="signup.teamworkCollection.uplift.heading"
            defaultMessage="Switch your site to Teamwork Collection"
        />
    );

    const content = (
        <>
            <Headings main={headingText} />
            <SiteActivation CrossflowEligibleUser={<SwitchYourSiteMessage />} />
        </>
    );

    if (twcSignupOverlayEnrolled) {
        return <TwcOverlayTemplate size="sm">{content}</TwcOverlayTemplate>;
    }

    return (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            {content}
        </SignupBackgroundLayout>
    );
};
